import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useEffect } from "react";

const SlideInOut = ({ children, threshold = 0.2, className = "", style = {} }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    triggerOnce: false,
    threshold,
  });

  useEffect(() => {
    if (inView) {
      controls.start({ opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } });
    } else {
      controls.start({ opacity: 0, y: 50, transition: { duration: 0.4, ease: "easeIn" } });
    }
  }, [inView, controls]);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 50 }}
      animate={controls}
      className={className}
      style={style}
    >
      {children}
    </motion.div>
  );
};

export default SlideInOut;
